var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V39.0807H39.0807V0H0ZM46.9193 0V39.0807H86V0H46.9193ZM7.78257 7.78257H31.2982V31.2982H7.78257V7.78257ZM54.7018 7.78257H78.2174V31.2982H54.7018V7.78257ZM15.6211 15.7331V23.5156H23.5156V15.7331H15.6211ZM62.4844 15.7331V23.5156H70.2669V15.7331H62.4844ZM0 46.9193V86H39.0807V46.9193H0ZM46.9193 46.9193V86H54.702V62.5964H62.4845V70.379H86V46.9193H78.2174V54.702H70.2669V46.9193H46.9193ZM7.78257 54.7018H31.2982V78.2174H7.78257V54.7018ZM15.6211 62.4844V70.3789H23.5156V62.4844H15.6211ZM62.4844 78.2174V86H70.2669V78.2174H62.4844ZM78.2174 78.2174V86H86V78.2174H78.2174Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.ec88c0c7c9841df68d871a9d859f4720.svg";
export { ForwardRef as ReactComponent };